import { render, staticRenderFns } from "./OrderProcessedL2PChart.vue?vue&type=template&id=17e846d8&scoped=true&"
import script from "./OrderProcessedL2PChart.vue?vue&type=script&lang=js&"
export * from "./OrderProcessedL2PChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e846d8",
  null
  
)

export default component.exports